/**
 * Placeholder articles the backend returns to every org's learners (test content
 * written in another context). Resources hides them, once, on the data that feeds
 * the "All (n)" count, the list and the article opened by default: hiding them in
 * the list alone left the count counting them and the detail pane opening one
 * ("Article Title"), so a library with no real resources looked like an empty list
 * beside someone else's test article (docs/BUG-learner-resources-hidden-article.md).
 */
export const HIDDEN_ARTICLE_IDS = new Set([
  '693add8caa05f14255470879',
  '6939c3ba77993b54576ba297',
  '6633b7f3d9535f1041c82157',
  '6633b6fb35852150eac639c3',
  '6633b65335852150eac6398b',
  '6633b54235852150eac63933'
]);

export const visibleArticles = <T extends { articleId?: string }>(articles: T[]): T[] =>
  articles.filter((article) => !HIDDEN_ARTICLE_IDS.has(String(article.articleId)));
